module.exports = __webpack_public_path__ + "media/images/edscap-campanha-web-ef26942f28d937b26e5fc1443913d6b4.png";